import { getResourceSearchResult } from "./ResourcesService";

/**
 * Fetch themes with filters.
 * @param {string} token - Auth token
 * @param {string} filtersUrlParams - URL parameters for filters
 * @param {number} page - Page number (default 0)
 * @param {number} size - Page size (default 10)
 * @returns {Promise<ResourceSearchResult>}
 */
export async function fetchThemesWithFilters(
  token,
  filtersUrlParams,
  page = 0,
  size = 10
) {
  const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;
  const url = `${BASE_URL}/pricethemes?${
    filtersUrlParams ? filtersUrlParams + "&" : ""
  }page=${page}&size=${size}`;
  const res = await fetch(url, {
    headers: { Authorization: token },
  });
  if (!res.ok) throw new Error("Failed to fetch themes");
  return getResourceSearchResult(token, await res.json());
}
